<template>
  <footer class="common-footer-component font-color-white">
    <div class="footer-container">
      <div class="content app-basic-layout-wrapper app-flex-row-space-between">
        <div class="left app-flex-row">
          <div class="about app-flex-column">
            <img src="@/assets/img/logo.png" alt="微博营销" class="logo" />
            <div class="main">
              <h3 class="font-16">关于我们</h3>
              <p class="font-13">
                微博营销官网是一个综合性的数字化营销平台，整合了微博旗下各产品的营销能力，汇聚流量、数据和内容，为广告主提供综合的数字营销解决方案，助力品牌高效达成营销推广目标。
              </p>
            </div>
          </div>
          <div class="nav-group app-flex-row">
            <nav class="nav">
              <h3 class="font-16">快速导航</h3>
              <ul class="app-flex-column font-13">
                <li
                  v-for="(item, index) in quickNav"
                  :key="index"
                  class="item"
                  @click="() => otherLink(item)"
                >
                  {{ item.name }}
                </li>
              </ul>
            </nav>
            <nav class="nav">
              <h3 class="font-16">服务支持</h3>
              <ul class="app-flex-column font-13">
                <li
                  v-for="(item, index) in internalNav"
                  :key="index"
                  class="item"
                  @click="() => selfLink(item)"
                >
                  {{ item.name }}
                </li>
              </ul>
            </nav>
          </div>
        </div>
        <div class="right app-flex-column">
          <h3 class="contact font-16 app-flex-row">
            <i class="iconfont icon-kefu font-18"></i>合作联系
          </h3>
          <p class="tel font-28">4000-970-970</p>
          <p class="email font-14">Email:smc@staff.weibo.com</p>
          <p class="time font-14">9:00~18:00 (周一到周五)</p>
        </div>
      </div>
    </div>
    <div class="copy-right">
      <div class="content app-basic-layout-wrapper app-flex-column">
        <p class="icp font-13">
          京ICP备12002058号 Copyright © 2009-2021 WEIBO
          北京微梦创科网络技术有限公司
        </p>
        <p class="font-12 address">
          公司地址：北京市海淀区东北旺西路中关村软件园二期（西扩）N-1、
          N-2地块新浪总部科研楼3层313-316室
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      quickNav: [
        {
          name: '营销案例',
          link: 'https://hd.weibo.com/senior/list?alk_from=P006_C070',
          module: 'foot_nav_senior'
        },
        {
          name: '广告产品',
          link: 'https://tui.weibo.com/platform',
          module: 'foot_nav_product'
        },
        {
          name: '达人推广',
          link: 'https://weirenwu.weibo.com/',
          module: 'foot_nav_kol'
        },
        {
          name: '品牌号',
          link: '/brand',
          module: 'foot_nav_brand'
        },
        {
          name: '创意素材',
          link: 'https://hd.weibo.com/originality/list?alk_from=P006_C070',
          module: 'foot_nav_originality'
        },
        {
          name: '行业资讯',
          link: '/article/list',
          module: 'foot_nav_article'
        }
      ],
      internalNav: [
        {
          name: '用户隐私协议',
          link: '/help/privacy',
          module: 'foot_nav_privacy'
        },
        {
          name: '服务使用协议',
          link: '/help/agreement',
          module: 'foot_nav_agreemant'
        }
      ]
    }
  },
  methods: {
    otherLink(item) {
      this.doStat(item)
      window.open(item.link, '_blank')
    },
    selfLink(item) {
      this.doStat(item)
      this.$router.push({ path: item.link })
    },
    doStat(item) {
      this.$stat({
        key: 'footer_click',
        params: { module: item.module },
        pathName: this.$route.name
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.common-footer-component {
  width: 100%;
  height: 457px;
  .footer-container {
    height: 382px;
    background-color: #1b222b;
    .content {
      align-items: flex-start;
      .left {
        align-items: flex-start;
        .about {
          width: 284px;
          padding-top: 78px;
          margin-right: 66px;
          .logo {
            height: 36px;
            width: 110px;
          }
          .main {
            h3 {
              padding: 40px 0 16px;
            }
          }
        }
        .nav-group {
          padding-top: 88px;
          align-items: flex-start;
          .nav {
            &:not(:last-of-type) {
              margin-right: 143px;
            }
            h3 {
              margin-bottom: 24px;
            }
            .item {
              cursor: pointer;
              margin-bottom: 14px;
            }
          }
        }
      }
      .right {
        padding-top: 132px;
        justify-content: start;
        align-items: flex-end;
        .contact {
          margin-bottom: 17px;
          font-weight: normal;
          .iconfont {
            margin-right: 8px;
          }
        }
        .email {
          margin-bottom: 10px;
        }
      }
    }
  }
  .copy-right {
    height: 75px;
    background: #161c24;
    .content {
      align-items: center;
      padding-top: 18px;
      .icp {
        opacity: 0.65;
        margin-bottom: 4px;
      }
      .address {
        opacity: 0.45;
      }
    }
  }
}
</style>
